import { AuthenticationService } from "../../../legacy/services/authentication-service/authentication.service";
import type { IAuthenticationService } from "../../../legacy/services/authentication-service/authentication.service.interface";

const logoutService: IAuthenticationService = new AuthenticationService();

export function useLogout() {
  return { logout: logoutService.logoutAndResetStorage.bind(logoutService) };
}
